import http from '@/service/http'
import { DriverCenterUrl } from '@/common/url'
import * as T from './types'

export const driverImApi: T.IDriverImApi = {
  getMsgByDialogueId(params) {
    return http.get(DriverCenterUrl.GetMsgByDialogueId, params)
  },
  sendMsg(params) {
    return http.post(DriverCenterUrl.SendMsg, params)
  },
  // getCarList(params) {
  //   return http.get(DriverCenterUrl.CarList, params)
  // },
  // uploadSignPicture(params) {
  //   return http.upload(DriverCenterUrl.UploadVehiclePicture, params)
  // },
  getFleetMessageList(params) {
    return http.get(DriverCenterUrl.FleetMessageList, params)
  },
  FleetUploadDialogue(params) {
    return http.post(DriverCenterUrl.FleetUploadDialogue, params)
  },

  getNewMsgCount(params) {
    return http.get(DriverCenterUrl.NewMsgCount, params)
  },
  addDialogue(params) {
    return http.post(DriverCenterUrl.AddDialogue, params)
  },

  createRecommendInvite(params) {
    return http.post(DriverCenterUrl.RecommendInvite, params)
  },
  getInviteDetail(params) {
    return http.get(DriverCenterUrl.InviteDetail, params)
  },
  ComfirmInvite(params) {
    return http.post(DriverCenterUrl.ComfirmInvite, params)
  },
  getInviteStatus(params) {
    return http.get(DriverCenterUrl.InviteStatus, params)
  },
}
